export default "__VITE_ASSET__B7kbkgFy__"